import Vue from "vue";
import VueResource from "vue-resource";
import ApiAuth from "../models/ApiAuth.js";
import Message from "../models/Message.js";
import Registration from "../models/Registration.js";
import RegistrationAttempt from "../models/RegistrationAttempt.js";
import buefy from 'buefy';
import es from 'vee-validate/dist/locale/es';
import VeeValidate from 'vee-validate';
import axios from "axios";
import Terms from "../models/Terms.js";
import PasswordBlacklist from "../models/PasswordBlacklist.js";
import { lang } from "moment";
import Default from "../models/Default.js";
import moment from "moment";
import RxeobDatepicker from "../components/RxeobDatepicker.vue";
import Account from "../models/Account.js";


Vue.use(VueResource);
Vue.use(VeeValidate);
Vue.use(buefy);
var headers = {
    Accept: "application/json"
};
ApiAuth.addAuthHeader(headers);

for (var k in headers) {
    Vue.http.headers.common[k] = headers[k];
}
Default.initializeHeaders(headers);

//Terms.initializeHeaders(headers);


var authApi = Vue.resource(Apollo.resolveApiUrl('~/Auth'), { headers: { Accept: 'application / json' } }, {
    authenticate: { method: 'POST', url: Apollo.resolveApiUrl('~/Auth') }
});

// add custom password validator to VeeValidate
var passwordCheckResults = {
    success: true,
    results: []
};


const passwordValidation = {
    regexChecks: [
        { regex: /[a-z]/, message: "At least 1 lowercase letter." },
        { regex: /[A-Z]/, message: "At least 1 uppercase letter." },
        { regex: /\d/, message: "At least 1 number." },
        { regex: /[!@#\$%\^&\*\?]/, message: "At least 1 approved special character." },
        { regex: /.{8,}/, message: "At least 8 total characters." }
    ],
    blacklistMessage: "Must not be on the password blacklist."
}

const passwordValidator = {
    getMessage: function (field, args) {
        return "Password must meet the criteria.";
    },
    validate: function (value, args) {
        passwordCheckResults.results = [];

        let me = this,
            success = true;

        for (let i = 0; i < passwordValidation.regexChecks.length; i++) {
            let check = passwordValidation.regexChecks[i];
            let pass = check.regex.test(value);

            passwordCheckResults.results.push({ success: pass, message: check.message });

            if (!pass) {
                success = false;
            }
        }

        if (success) {
            return PasswordBlacklist.validate(value)
                .then(function (result) {
                    //console.log("result", result);
                    passwordCheckResults.results.push({ success: result.data, message: passwordValidation.blacklistMessage });
                    return result.data;
                });
        } else {
            passwordCheckResults.results.push({ success: false, message: passwordValidation.blacklistMessage });
        }

        passwordCheckResults.success = success;
        return success;
    },
};

VeeValidate.Validator.extend("password", passwordValidator);

var loginApp = new Vue({
    el: '#login_Main',
    components: {
        RxeobDatepicker: RxeobDatepicker
    },
    data: {
        popUpReset: true,
        loginId: '',
        password: '',
        resetFirstName: '',
        resetLastName: '',
        //resetSubscriberId: '',
        resetDob: undefined,
        resetEmail: '',
        resetUsernameFirstName: '',
        resetUsernameLastName: '',
        //resetSubscriberId: '',
        resetUsernameDob: undefined,
        resetUsernameEmail: '',
        resetPasswordFirstName: '',
        resetPasswordLastName: '',
        //resetSubscriberId: '',
        resetPasswordDob: undefined,
        resetPasswordEmail: '',
        name: '',
        phone: '',
        defaults: [],
        buttonCancelText: "",
        buttonSendMsgText: "",
        footerContactusText: "",
        footerEspanolText: "",
        footerPrivacyText: "",
        footerTermsofuseText: "",
        footerText: "",
        forgetPasswordText: "",
        forgetUsernameText: "",
        helpMsgbox1Text: "",
        helpMsgbox2Text: "",
        helpMsgbox3Text: "",
        helpText: "",
        loginSignInText: "",
        loginTitleHeaderText: "",
        userHelpSubtitleText: "",
        userHelpTitleText: "",
        appNameText: "",
        usernameText: "",
        passwordText: "",
        registerText: "",
        firstNameText: "",
        lastNameText: "",
        dateOfBirthText: "",
        selectDateText: "",
        declaineText: "",
        acceptText: "",
        registrationText: "",
        passwordValidationMsgText: "",
        resetPasswordText: "",
        emailText: "",
        recaptchaBrandingText: "",
        declineText: "",
        submitText: "",
        nameText: "",
        memberIdText: "",
        optionalText: "",
        phoneText: "",
        versionText: "",
        privacyPolicyLinkText: "",
        resetMessageText: "",
        emailWarningText: "",
        alreadyRegisteredTitleText: "",
        alreadyRegisteredMessageText: "",
        idCardLinkText: "",
        previousText: "",
        nextText: "",
        redirectClient1LogoText: "",
        redirectClient2LogoText: "",
        redirectClient3LogoText: "",
        redirectClient1URLText: "",
        redirectClient2URLText: "",
        redirectClient3URLText: "",
        redirectClient1Text: "",
        redirectClient2Text: "",
        redirectClient3Text: "",
        redirectBoxTitleText: "",
        redirectBoxDescText: "",
        isselecthealth: false,
        email: '',
        memberId: '',
        messageType: 0,
        messageModalActive: false,
        showCreateMessage: false,
        showUserHelp: true,
        showBenefitHelp: false,
        resetType: -1,
        showLinkModal: false,
        showCardsModal: false,
        showAlreadyRegisteredModal: false,
        //showResetModal: false,
        resetText: '',
        linkModalTitle: '',
        linkModalText: '',
        forgotLinks: true,
        registerModal: false,
        registerFields: [],
        registrationErrorMessages: {
            MemberNotFound: "",
            FieldValidationFailed: "",
            MemberAlreadyRegistered: "",
            PasswordRequirementsFailed: "",
            MissingRequiredFields: "",
            LoginIdInUse: "",
            IpBan: "",
            Unknown: ""
        },
        registrationError: null,
        showTermsModal: false,
        showUsernameResetModal: false,
        showPasswordResetModal: false,
        termsModalTitle: "",
        termsModalText: "",
        language: "English",
        dateFormat: ["month", "day", "year"],
        currentCard: 0
    },
    mounted: function () {
        var me = this;
        me.loadDefaults();

        Registration.getFields().then(function (res) {
            for (var i = 0; i < res.data.length; i++) {
                me.registerFields.push(res.data[i]);
            }
        }).catch(function (error) {
            console.log(error);
        });
    },
    methods: {
        loadValidator: function () {

        },
        handleEnter: function (event) {
            if (event.keyCode === 13) {
                this.loginClick();
            }
        },
        dateFormatter: function (d) {
            return ApolloFilters.datePicker(d);
        },
        closeResetModal: function () {
            this.resetType = -1;
            this.showUsernameResetModal = false;
            this.showPasswordResetModal = false;
        },
        closePopUpReset: function () {
            this.popUpReset = false;
        },
        resetClickFromModal: function () {
            this.closePopUpReset();
            this.registerModal = true;
        },
        checkIfTextExists: function () {
            return this.resetMessageText != null && this.resetMessageText != undefined && this.resetMessageText.length > 0;
        },
        loadDefaults: function () {
            var me = this;
            const loadingComponent = this.$buefy.loading.open({
                container: true ? null : me.$refs.element.$el
            })
            Default.GetForViewNoAuth("login").then(function (res) {
                me.defaults = res.data;
                me.language = me.defaults[0].language;
                me.loadText();
                loadingComponent.close();
            }).catch(function (error) {
                console.log(error);
                loadingComponent.close();
            });
        },
        getDefault: function (nameKey) {
            return Default.Find(nameKey, this.defaults);
        },
        loadText: function () {
            this.buttonCancelText = this.getDefault("button_cancel");
            this.buttonSendMsgText = this.getDefault("button_send_msg");
            this.footerContactusText = this.getDefault("footer_contactus");
            this.footerEspanolText = this.getDefault("footer_espanol");
            this.footerPrivacyText = this.getDefault("footer_privacy");
            this.footerTermsofuseText = this.getDefault("footer_termsofuse");
            this.footerText = this.getDefault("footer_text");
            this.forgetPasswordText = this.getDefault("forget_password");
            this.forgetUsernameText = this.getDefault("forget_username");
            this.helpMsgbox1Text = this.getDefault("help_msgbox_1");
            this.helpMsgbox2Text = this.getDefault("help_msgbox_2");
            this.helpMsgbox3Text = this.getDefault("help_msgbox_3");
            this.helpText = this.getDefault("help_text");
            this.loginSignInText = this.getDefault("login_sign_in");
            this.loginTitleHeaderText = this.getDefault("login_title_header");
            this.userHelpSubtitleText = this.getDefault("user_help_subtitle");
            this.userHelpTitleText = this.getDefault("user_help_title");
            this.appNameText = this.getDefault("app_name");
            this.usernameText = this.getDefault("username");
            this.passwordText = this.getDefault("password");
            this.registerText = this.getDefault("register");
            this.firstNameText = this.getDefault("first_name");
            this.lastNameText = this.getDefault("last_name");
            this.dateOfBirthText = this.getDefault("date_of_birth");
            this.selectDateText = this.getDefault("select_date");
            this.emailText = this.getDefault("email");
            this.submitText = this.getDefault("submit");
            this.recaptchaBrandingText = this.getDefault("recaptcha_branding");
            this.declineText = this.getDefault("decline");
            this.acceptText = this.getDefault("accept");
            this.registrationText = this.getDefault("registration");
            this.passwordValidationMsgText = this.getDefault("password_validation_msg");
            this.resetPasswordText = this.getDefault("reset_password");
            this.nameText = this.getDefault("name");
            this.memberIdText = this.getDefault("member_id");
            this.optionalText = this.getDefault("optional");
            this.phoneText = this.getDefault("phone");
            this.versionText = this.getDefault("version");
            this.termsModalTitle = this.getDefault("tos_title");
            this.termsModalText = this.getDefault("tos_text");
            this.privacyPolicyLinkText = this.getDefault("privacy_policy_link");
            this.resetMessageText = this.getDefault("reset_message");
            this.emailWarningText = this.getDefault("email_warning");
            this.alreadyRegisteredTitleText = this.getDefault("already_registered_title");
            this.alreadyRegisteredMessageText = this.getDefault("already_registered_text");
            this.idCardLinkText = this.getDefault("id_cards_link");
            this.previousText = this.getDefault("previous");
            this.nextText = this.getDefault("next");
            this.redirectClient1Text = this.getDefault("redirect_client_1");
            this.redirectClient2Text = this.getDefault("redirect_client_2");
            this.redirectClient3Text = this.getDefault("redirect_client_3");
            this.redirectClient1LogoText = this.getDefault("redirect_client_1_logo");
            this.redirectClient2LogoText = this.getDefault("redirect_client_2_logo");
            this.redirectClient3LogoText = this.getDefault("redirect_client_3_logo");
            this.redirectClient1URLText = this.getDefault("redirect_client_1_url");
            this.redirectClient2URLText = this.getDefault("redirect_client_2_url");
            this.redirectClient3URLText = this.getDefault("redirect_client_3_url");
            this.redirectBoxTitleText = this.getDefault("redirect_box_title");
            this.redirectBoxDescText = this.getDefault("redirect_box_desc");

            this.registrationErrorMessages.MemberNotFound = this.getDefault("member_not_found");
            this.registrationErrorMessages.FieldValidationFailed = this.getDefault("field_validation_failed");
            this.registrationErrorMessages.MemberAlreadyRegistered = this.getDefault("member_already_registered");
            this.registrationErrorMessages.PasswordRequirementsFailed = this.getDefault("password_requirements_failed");
            this.registrationErrorMessages.MissingRequiredFields = this.getDefault("missing_required_fields");
            this.registrationErrorMessages.LoginIdInUse = this.getDefault("login_id_in_use");
            this.registrationErrorMessages.IpBan = this.getDefault("ip_ban");
            this.registrationErrorMessages.Unknown = this.getDefault("unknown");

            if (this.language === "Spanish") {
                var me = this;
                const dictionary = {
                    es: {
                        attributes: {
                            name: me.getDefault("name"),
                            memberid: me.getDefault("memberId"),
                            email: me.getDefault("email"),
                            phone: me.getDefault("phone")
                        }
                    }
                };

                VeeValidate.Validator.localize(dictionary);
                VeeValidate.Validator.localize('es', es);

                me.dateFormat = ["day", "month", "year"];
            }
        },
        resetUsername: function (recaptchaSiteKey) {
            var me = this;
            var action = me.resetType == 0 ? "ForgotUsername" : "ForgotPassword";

            grecaptcha.ready(function () {
                grecaptcha.execute(recaptchaSiteKey, { action: action }).then(function (token) {
                    var d = me.resetUsernameDob;
                    //Add offset back for reset password and username
                    var offset = d.getTimezoneOffset();
                    d.setMinutes(offset)

                    var new_dob = d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear();
                    var obj = {
                        "FirstName": me.resetUsernameFirstName,
                        "LastName": me.resetUsernameLastName,
                        "Dob": new_dob,
                        //"SubscriberId": this.resetSubscriberId,
                        "Email": me.resetUsernameEmail,
                        "Token": token
                    };

                    if (me.resetType == 0) {
                        // Reset username.
                        axios.post(
                            Apollo.resolveApiUrl("~/reset/username"), obj).then(function (res) {
                                me.resetUsernameFirstName = "";
                                me.resetUsernameLastName = "";
                                me.resetUsernameDob = undefined;
                                me.resetUsernameEmail = "";
                                //me.resetSubscriberId = "";
                                me.showUsernameResetModal = false;

                                me.$buefy.toast.open({
                                    message: me.getDefault("request_username"),
                                    type: 'is-success',
                                    duration: 4000
                                });
                            }).catch(function (error) {
                                me.$buefy.toast.open({
                                    message: me.getDefault("request_failed"),
                                    type: 'is-danger',
                                    duration: 4000
                                });
                            });
                    }
                });
            });
        },
        resetPassword: function (recaptchaSiteKey) {
            var me = this;
            var action = me.resetType == 0 ? "ForgotUsername" : "ForgotPassword";

            grecaptcha.ready(function () {
                grecaptcha.execute(recaptchaSiteKey, { action: action }).then(function (token) {
                    var d = me.resetPasswordDob;
                    //Add offset back for reset password and username
                    var offset = d.getTimezoneOffset();
                    d.setMinutes(offset)

                    var new_dob = d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear();
                    var obj = {
                        "FirstName": me.resetPasswordFirstName,
                        "LastName": me.resetPasswordLastName,
                        "Dob": new_dob,
                        //"SubscriberId": this.resetSubscriberId,
                        "Email": me.resetPasswordEmail,
                        "Token": token
                    };

                    if (me.resetType == 1)  {
                        axios.post(
                            Apollo.resolveApiUrl("~/reset/password"), obj).then(function (res) {
                                me.resetPasswordFirstName = "";
                                me.resetPasswordLastName = "";
                                me.resetPasswordDob = undefined;
                                me.resetPasswordEmail = "";
                                //me.resetSubscriberId = "";
                                me.showPasswordResetModal = false;

                                me.$buefy.toast.open({
                                    message: me.getDefault("request_password"),
                                    type: 'is-success',
                                    duration: 4000
                                });
                            }).catch(function (error) {
                                me.$buefy.toast.open({
                                    message: me.getDefault("request_failed"),
                                    type: 'is-danger',
                                    duration: 4000
                                });
                            });
                    }
                });
            });
        },
        resetClick: function (reset_type) {
            // reset username
            this.resetType = reset_type;
            if (reset_type == 0) {
                this.resetText = this.getDefault("forgot_username_title");
                this.showAlreadyRegisteredModal = false;
                this.showUsernameResetModal = true;
            }
            else {
                this.resetText = this.getDefault("forgot_password_title");
                this.showAlreadyRegisteredModal = false;
                this.showPasswordResetModal = true;
            }

        },
        loginClick: function () {
            var me = this;

            if (me.password == '' && me.loginId == '') {
                this.loginFailed("missing_both");
            }
            else if (me.password != '' && me.loginId == '') {
                this.loginFailed("missing_username");
            }
            else if (me.password == '' && me.loginId != '') {
                this.loginFailed("missing_password");

            } else {
                const loadingComponent = this.$buefy.loading.open({
                    container: true ? null : me.$refs.element.$el
                })

                ApiAuth.login({ username: me.loginId, password: me.password },
                    // onSuccess
                    function () {
                        //window.location = Apollo.resolveAppUrl("~/claims/");

                        var headers = {
                            Accept: "application/json"
                        };
                        /*for (var k in headers) {
                            Vue.http.headers.common[k] = headers[k];
                        }*/
                        ApiAuth.addAuthHeader(headers);
                        //timing is a little tricky here
                        Terms.initializeHeaders(headers);
                        Terms.get().then(function (res) {
                            if (res.data == false) {
                                loadingComponent.close();
                                me.showTermsModal = true;
                            } else {
                                Account.getUser().then(function (response) {
                                    me.user = response.data;
                                    
                                    var hasMemberServices = me.user.Roles.includes("member_services");
                                    window.location = Apollo.resolveAppUrl("~/MemberServices/");

                                    if (!hasMemberServices) {
                                        if (me.user.Member.PrimaryEligibility.IsActive == true) {
                                            window.location = Apollo.resolveAppUrl("~/home/");
                                        } else {
                                            window.location = Apollo.resolveAppUrl("~/claims/");
                                        }
                                    }


                                }).catch(function (error) {
                                    console.log(error);
                                });  
                            }
                        }).catch(function (error) {
                            console.log(error);
                        });
                    },
                    // onError
                    function (err) {
                        console.log("error authenticating", err);
                        loadingComponent.close();
                        me.loginFailed(err);
                    });
            }
        },
        loginFailed: function (key) {
            var msg = this.getDefault(key)

            this.$buefy.toast.open({
                message: msg,
                type: 'is-danger',
                duration: 5000
            });
        },
        getDefaults: function () {
            var me = this;
            Default.GetForViewNoAuth("auth").then(function (res) {
                
                me.defaults = res.data;
                console.log(me.defaults);
            });
        },

        ChangeURL: function (value) {
            if (value == 1) {
                window.location = this.redirectClient1URLText
            };
            if (value == 2) {
                window.location = this.redirectClient2URLText
            };
            if (value == 3) {
                window.location = this.redirectClient3URLText
            };
        },
        isSelecthealth: function (healthplan) {
            if (healthplan == 31 || healthplan == 74 || healthplan == 76 || healthplan == 999) {
                this.isselecthealth = true
            }
            if (healthplan == 74 || healthplan == 76) {
                this.redirectClient1LogoText = "/mdb/Content/apollo/img/sh-logo.png"   
                this.redirectClient2LogoText = "/mdb/Content/apollo/img/sh_Scripius_Logo.png"
                this.redirectClient3LogoText = "/mdb/Content/apollo/img/AVHP-LOGO.png"
            }
        },
        renderDefault: function (k) {
            console.log(this.defaults);
            if (jQuery.isEmptyObject(this.defaults)) {
                this.getDefaults();
            }
            if (this.defaults.hasOwnProperty(k)) {
                return this.defaults[k];
            }
        },
        sendMessage: function () {

            var createdMessage = {
                "RecipientRole": "technical"
            }
            var me = this;

            if (this.messageType === 1) {
                createdMessage["Subject"] = "Registration Issue";
                createdMessage["Body"] =
                    `The following member is having issues registering for an account. 
Name: ${this.name} 
Email: ${this.email} 
MemberId: ${this.memberId} 
Phone: ${this.phone}`;

                createdMessage["Tags"] = 4;
                Message.create(createdMessage).then(function (res) {
                    //Close up the modals and make a toast :)
                    me.sendConfirmation();
                }).catch(function (error) {
                    console.log(error);
                });

            }
            if (this.messageType === 2) {
                createdMessage["Subject"] = "Login Issue";
                createdMessage["Body"] =
                    `The following member is having issues logging into their account. 
Name: ${this.name} 
Email: ${this.email} 
MemberId: ${this.memberId} 
Phone: ${this.phone}`;

                createdMessage["Tags"] = 3;
                Message.create(createdMessage).then(function (res) {
                    //Close up the modals and make a toast :)
                    me.sendConfirmation();
                }).catch(function (error) {
                    console.log(error);
                });
            }
        },

        cancelTerms: function () {
            ApiAuth.logout();
            this.loginId = "";
            this.password = "";
            this.showTermsModal = false;
        },  

        acceptTerms: function () {
            var me = this;

            const loadingComponent = me.$buefy.loading.open({
                container: true ? null : me.$refs.element.$el
            })

            Terms.accept(true).then(function(res){
                console.log("all good");
                console.log(res)
                ApiAuth.logout();
                //login again to get a new token with the appropriate claim values
                me.loginClick();
                loadingComponent.close();
            }).catch(function (error) {
                console.log(error);
                loadingComponent.close();
            });
            //window.location = Apollo.resolveAppUrl("~/claims/");
        },

        openLinkModal: function (event, title) {
            var titleKey;
            var textKey;

            switch (title) {
                case 'privacy':
                    titleKey = "privacy_title";
                    textKey = "privacy_text";
                    break;
                case 'tos':
                    titleKey = "tos_title";
                    textKey = "tos_text";
                    break;
            }

            this.linkModalTitle = this.getDefault(titleKey);
            this.linkModalText = this.getDefault(textKey);

            this.showLinkModal = true;
        },
        showUserHelpBox: function () {
            this.messageModalActive = true;
            this.showUserHelp = true;
            this.showBenefitHelp = false;
            this.showCreateMessage = false;
        },
        showBenefitHelpBox: function () {
            this.messageModalActive = true;
            this.showUserHelp = false;
            this.showBenefitHelp = true;
            this.showCreateMessage = false;
        },
        showMessageBox: function (msgType) {
            this.name = '';
            this.email = '';
            this.memberId = '';
            this.phone = '';
            this.$validator.reset();
            this.messageType = msgType;
            this.showCreateMessage = true;
            this.showUserHelp = false;
        },
        modalCallback: function () {
            this.messageModalActive = false;
            this.showUserHelp = true;
            this.showBenefitHelp = false;
            this.showCreateMessage = false;

            this.messageType = 0;
        },
        sendConfirmation: function () {
            var me = this;
            this.$buefy.toast.open({
                message: me.getDefault("message_delivered"),
                type: 'is-success'
            });
            this.modalCallback();
        },
        checkRegistration: function (recaptchaSiteKey) {
            var me = this;
            me.$validator.validateAll().then((result) => {
                if (result) {
                    console.log("The form is valid. Make a post to the api with the values, and close the modal.", result, me.registerFields);
                    //Trim Whitespace off the first name and last name in order to match information in the system.
                    if (me.registerFields) {
                        for (var i = 0; me.registerFields.length > i; i++) {
                            if (me.registerFields[i].Name === "first_name" || me.registerFields[i].Name === "last_name") {
                                me.registerFields[i].Value = me.registerFields[i].Value.trim();
                            }
                        }
                    }

                    grecaptcha.ready(function () {
                        grecaptcha.execute(recaptchaSiteKey, { action: "Register" }).then(function (token) {
                            var attempt = {
                                FieldValues: me.registerFields,
                                Token: token
                            };

                            RegistrationAttempt.post(attempt)
                                .then((results) => {

                                    me.$buefy.toast.open({
                                        message: me.getDefault("successfully_registered"),
                                        type: 'is-success',
                                        position: 'is-top',
                                        duration: 6000
                                    });
                                    me.registerModal = false;

                                    console.log("submit response", results);
                                })
                                .catch(function (err) {
                                    console.log("registration error", err.response);
                                    let failureCode = (err.response && err.response.data) ? err.response.data.FailureCode : "Unknown";

                                    if (failureCode === "MemberAlreadyRegistered") {
                                        me.resetRegister();
                                        me.showAlreadyRegisteredModal = true;
                                    } else {
                                        me.$buefy.toast.open({
                                            message: me.translateRegistrationFailureCode(failureCode),
                                            type: "is-danger",
                                            position: "is-bottom",
                                            duration: 6000
                                        });
                                    }
                                });
                        });
                    });
                }
                else {
                    me.$buefy.toast.open({
                        message: me.getDefault("check_fields"),
                        type: 'is-danger',
                        position: 'is-bottom',
                        duration: 4000
                    });
                }
            });
        },
        resetRegister: function () {
            this.registerModal = false;
            passwordCheckResults.results = [];

            for (var i = 0; i < this.registerFields.length; i++) {
                this.registerFields[i]["Value"] = null;
            }
        },
        checkForm: function () {
            var me = this;
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.sendMessage();
                } else {
                    this.$buefy.toast.open({
                        message: me.getDefault("check_fields"),
                        type: 'is-danger',
                        position: 'is-bottom',
                        duration: 4000
                    });
                }
            });
        },
        translateRegistrationFailureCode: function (code) {
            return this.registrationErrorMessages[code] || this.registrationErrorMessages["Unknown"]
        },
        getPasswordCheckResults: function () {
            return passwordCheckResults.results;
        },
        isPasswordValid: function () {
            return passwordCheckResults.success;
        }
    }
});



// WEBPACK FOOTER //
// ./src/apps/LoginApp.js